// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NotSupported_wrapper__2lrRf"};